import { render, staticRenderFns } from "./DomainRegistrationWizard.vue?vue&type=template&id=33dfd9f9&"
import script from "./DomainRegistrationWizard.vue?vue&type=script&lang=js&"
export * from "./DomainRegistrationWizard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports